
import React, { useState, useEffect, useRef  } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc, doc, getDoc, updateDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate, useParams } from "react-router-dom"
import { TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [premiumServiceCharge, setPremiumServiceCharge] = useState("")

  const [regularServiceCharge, setRegularServiceCharge] = useState("")

  const [visaFee, setVisaFee] = useState("")

  const [errorPremiumServiceCharge, setErrorPremiumCharge] = useState(false)

  const [errorRegularServiceCharge, setErrorRegularServiceCharge] = useState(false)

  const [errorVisaFee, setErrorVisaFee] = useState(false)

  const navigate = useNavigate();
  
  const {dollarChargeId} = useParams()



const getDollarCharge = async() => {

    const docRef = doc(db, "dollarCharges", dollarChargeId);

    const docSnap = await getDoc(docRef);

        
    if (docSnap.exists()) {

      setPremiumServiceCharge(docSnap.data().premiumServiceCharge)

      setRegularServiceCharge(docSnap.data().regularServiceCharge)

      setVisaFee(docSnap.data().visaFee)

    } else {
      
      console.log("No such document!");
    }


}

// console.log('charges: ',charges)



 

useEffect(()=>{

  getDollarCharge()

}, [])



    
    const handleDollarCharges = async(e) => {
  
      e.preventDefault()

      if(premiumServiceCharge === ""){
        
        return setErrorPremiumCharge("This field is required")
      }

       if(regularServiceCharge === ""){
        
        return setErrorRegularServiceCharge("This field is required")
      }

      if(visaFee === ""){
        
        return setErrorVisaFee("This field is required")
      }


      setIsloading(true)


      try {

          await updateDoc(doc(db, "dollarCharges", dollarChargeId), {
    
              premiumServiceCharge: Number(premiumServiceCharge),
              regularServiceCharge: Number(regularServiceCharge),
              visaFee: Number(visaFee),
              createdAt: today,
    
          })

             setIsloading(false)

             navigate("/dollarCharges")


        
      } catch (error) {
        
        console.log(error);
        
      }


      
  
      // try{
           
      //    const advertResponse = await addDoc(collection(db, "dollarCharges"), {
        
      //     premiumServiceCharge: Number(premiumServiceCharge),
      //     regularServiceCharge: Number(regularServiceCharge),
      //     visaFee: Number(visaFee),
      //     createdAt : today,
          
      //   });

      //   setIsloading(false)

      //   navigate("/dollarCharges")
        
      // }catch (err) {

      //   console.log(err);

      // } 
  
    }

    const handlePremiumService = (e) => {

          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setPremiumServiceCharge(onlyNums)

         if(premiumServiceCharge !== ""){

          setErrorPremiumCharge(false)
          
         }

    }

    
    const handleRegularService = (e) => {

         
          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setRegularServiceCharge(onlyNums )

         if(regularServiceCharge !== ""){

          setErrorRegularServiceCharge(false)
          
         }

    }


    const handleVisaFee = (e) => {

         
          const { value } = e.target; 
          
          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setVisaFee(onlyNums )

         if(visaFee !== ""){

          setErrorVisaFee(false)
          
         }    

      }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>Edit Dollar Charges</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/dollarCharges"
            >
              Dollar Charge List
            </Link>
            <Typography color="green">Edit Dollar Charge</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>


                  
                  
                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="premiumServiceCharge"
                          placeholder="Premium Service Charge eg 200"
                          value={premiumServiceCharge}
                          onChange={handlePremiumService}
                          style={{width:'100%', backgroundColor:'#bdcdf6'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorPremiumServiceCharge &&

                          <p style={{color:'red', fontSize:15, }}>{errorPremiumServiceCharge}</p>

                        }

                    </div>

                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="regularServiceCharge"
                          placeholder="Enter Regular Service Charge eg 160"
                          value={regularServiceCharge}
                          onChange={handleRegularService}
                          style={{width:'100%', backgroundColor:'#bdcdf6'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorRegularServiceCharge &&

                          <p style={{color:'red', fontSize:15, }}>{errorRegularServiceCharge}</p>

                        }

                    </div>


                     <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="visaFee"
                          placeholder="Enter Visa Fee eg 300"
                          value={visaFee}
                          onChange={handleVisaFee}
                          style={{width:'100%', backgroundColor:'#bdcdf6'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorVisaFee &&

                          <p style={{color:'red', fontSize:15, }}>{errorVisaFee}</p>

                        }

                      </div>


                
                </div>

                <hr style={{width:'100%', height:0, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handleDollarCharges} 
                    disabled={isloading}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...loading Dollar Charges' : 'Save Dollar Charges'}
                    
                  </Button>

          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New

















// import React, { useState } from 'react'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
// import { useEffect } from 'react';
// import Typography from '@mui/material/Typography';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
// import { collection, addDoc, serverTimestamp, doc, getDoc,  } from "firebase/firestore";
// import { useNavigate,  useParams } from "react-router-dom"
// import { auth, db, storage } from '../../../firebase'



// const Edit = ({inputs, title}) => {

//   // const [file, setFile ] = useState("")
//   const [ data, setData ] = useState({})
//   // const [ perc, setPerc ] = useState(null)
//   const [ isloading, setIsloading ] = useState(false)

//   const [charges, setCharges] = useState([])

//   const navigate = useNavigate();

// //   const params = useParams()
//   const {chargeId} = useParams()

// //   console.log("charge Id: ", chargeId)


//   const Spinner = () => {
//     return(
//       <span className='spinner-container'>
//           <span className='loading-spinner'></span>
//       </span>
//     )
//   }

//   const getCharge = async() => {

//     const docRef = doc(db, "charges", chargeId);

//     const docSnap = await getDoc(docRef);

        
//     if (docSnap.exists()) {

//       setCharges(docSnap.data() )

//     } else {
      
//       console.log("No such document!");
//     }


// }

// console.log('charges: ',charges)



 

// useEffect(()=>{

//   getCharge()

// }, [])


  


//   const handleInput = (e) =>{
//     const id = e.target.id;
//     const value = e.target.value;

//     setData({...charges, [id]:charges.id})
//   }

  
//   const handleAdd = async(e) => {

//     e.preventDefault()
//     setIsloading(true)

//     try{
       
       
//        await addDoc(collection(db, "charges"), {
//         ...data, charges : 'visaCharges',
//         timeStamp: serverTimestamp(),
        

//       });
      
//       setIsloading(false)

//       navigate('/charges')
      
      
//     }catch (err) {
//       console.log(err);
//     } 

//   }
// console.log(charges)
//   return (
//     <div className="new">
//       <Sidebar/>
//       <div className="newContainer">
//       <Navbar/>
//         <div className='top'>
//         <div className='topLeft'><h1>{title}</h1></div>
          
//           <div className='topRight'>
//           <Breadcrumbs aria-label="breadcrumb">
//             <Link underline="hover" color="inherit" href="/">
//               Home
//             </Link>
//             <Link
//               underline="hover"
//               color="inherit"
//               href="/charges"
//             >
//               Charges List
//             </Link>
//             <Typography color="green">Add Charges</Typography>
//           </Breadcrumbs>
//           </div>
//         </div>
        
//         <div className='bottom'>
        
//           <div className='right'>
//             <form onSubmit={handleAdd}>

//                 <div className='formInput' >
//                     <label>Company Introduction:</label>
//                     <input type="text" placeholder="$15" value={charges.companyIntroduction} onChange={handleInput} id="companyIntroduction" required/>
//                 </div>

//                 <div className='formInput' >
//                     <label>Self Introduction:</label>
//                     <input type="text" placeholder="$15" value={charges.selfIntroduction}  onChange={handleInput} id="selfIntroduction" required/>
//                  </div>

//                  <div className='formInput' >
//                     <label>Leave Approval:</label>
//                     <input type="text" placeholder="$15" value={charges.leaveApproval}  onChange={handleInput} id="leaveApproval" required/>
//                 </div>

//                 <div className='formInput' >
//                     <label>Employment Letter:</label>
//                     <input type="text" placeholder="$15" value={charges.employmentLetter}  onChange={handleInput} id="employmentLetter" required/>
//                  </div>

//                  <div className='formInput' >
//                     <label>Visa Processing Fee:</label>
//                     <input type="text" placeholder="$15" value={charges.visaProcessingFee}  onChange={handleInput} id="visaProcessingFee" required/>
//                 </div>

//              <button type='submit'>
//               {isloading && <span>...</span>}
//               {isloading ? <span>loading</span> : <span>Submit</span>}

              
//              </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Edit
